export default "__VITE_ASSET__Dj3PGMdN__"